var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.styles && _vm.styles[_vm.id] && _vm.palette[_vm.styles[_vm.id]])?_c('span',{staticClass:"vp-color-display",style:(`background: ${_vm.colour ? _vm.colour: ''}`)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }